export default class CreativeChallengeBrowserNav {
  constructor(element) {
    this.element = element;
  }

  init() {
    this.installRouteListener();
    this.update();
  }

  installRouteListener() {
    $(window).on('hashchange', () => {
      this.update();
    });
  }

  update() {
    const canonical = (url) => url.replace(/\/(\d+)$/, '').replace('.html', '');
    $(this.element).find('.nav-link').removeClass('active');
    $(this.element).find('.nav-link').each((j, navLink) => {
      if (canonical(window.location.href).includes(canonical($(navLink).attr('href')))) {
        $(navLink).addClass('active');
      }
    });
  }
}
